import { useIntl } from "react-intl";

const DeploymentTracking = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.DeploymentTracking.header",
            defaultMessage: "Deployment tracking"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.DeploymentTracking.body",
            defaultMessage:
                "Set up deployment tracking for your service project to create change requests when your team initiates deployments to selected services."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default DeploymentTracking;
